import { render, staticRenderFns } from "./BioCard.vue?vue&type=template&id=c24dab1e&scoped=true&"
import script from "./BioCard.vue?vue&type=script&lang=js&"
export * from "./BioCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24dab1e",
  null
  
)

export default component.exports